import type { SessionOrg, SessionUser } from '@/types/session.types';
import { hasEditPermission } from '@/utils/hubPermissions/hasPermissions';

export type DynamicMeetingsPermissionKey =
  | 'cisInternalMeetingParameters'
  | 'cisInternalMeetingTemplates';

/**
 * Grants access when the feature is edit-enabled on both the user AND the org,
 * consistent with the Hub default permission model.
 */
export function hasEditOnUserAndOrg(
  user: SessionUser | undefined,
  org: SessionOrg | undefined,
  permission: DynamicMeetingsPermissionKey
): boolean {
  return (
    hasEditPermission(user ?? {}, permission) &&
    hasEditPermission(org ?? {}, permission)
  );
}

export function canEditMeetingParameters(
  user: SessionUser | undefined,
  org: SessionOrg | undefined
): boolean {
  return hasEditOnUserAndOrg(user, org, 'cisInternalMeetingParameters');
}

export function canEditMeetingTemplates(
  user: SessionUser | undefined,
  org: SessionOrg | undefined
): boolean {
  return hasEditOnUserAndOrg(user, org, 'cisInternalMeetingTemplates');
}

export function canAccessParameterConfiguration(
  user: SessionUser | undefined,
  org: SessionOrg | undefined
): boolean {
  return (
    canEditMeetingParameters(user, org) || canEditMeetingTemplates(user, org)
  );
}
